import { PRODUCTION, DEVELOPMENT, LOCAL_SOURCE_ATLAS_URL } from "./const";
import { isEmpty } from "lodash";

export function sourceAtlasUrl() {
  const REACT_ENV = process.env.NODE_ENV;
  const SOURCE_ATLAS_URL = !!process.env.REACT_APP_SOURCE_ATLAS_URL && process.env.REACT_APP_SOURCE_ATLAS_URL !== "" ? process.env.REACT_APP_SOURCE_ATLAS_URL : "";
  if (!isEmpty(REACT_ENV)) {
    switch (REACT_ENV) {
      case DEVELOPMENT:
        return LOCAL_SOURCE_ATLAS_URL;
      case PRODUCTION:
        return SOURCE_ATLAS_URL;
      default:
        return LOCAL_SOURCE_ATLAS_URL;
    }
  } else {
    return LOCAL_SOURCE_ATLAS_URL;
  }
}

export const getSourceAtlasUrl = () => {
  return `${sourceAtlasUrl()}`;
};
